import axios from "axios";
import { IBooking, IBookingPermission } from "../../types";
import { IBookingsApiFilter, ISortBy } from "../types";

export interface IGetBookingsParams {
    filters?: IBookingsApiFilter,
    sortBy?: ISortBy,
    start?: number,
    limit?: number
}

export interface IGetBookingsReturn {
    rows: {
        booking: IBooking,
        permission: IBookingPermission
    }[]
}

export const getBookings = async (params: IGetBookingsParams): Promise<IGetBookingsReturn> => {
    const response = await axios.post('/booking/search/basic-search', params);
    return response.data;
};